import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { MuscleVolumePage } from './muscle-volume-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [MuscleVolumePage],
    imports: [PagesModule, ComponentsModule]
})
export class MuscleVolumePageModule { }
